import Layout from 'Nori/Layout';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import HeroFull from 'Nori/Hero/HeroFull';
import RichText from 'Custom/RichText';
import AjustableImage from 'Custom/AjustableImage';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import { Finder } from 'Custom/Finder';
import { Pregnancies } from 'Custom/Pregnancies';
import PLUS_IMAGE_DESKTOP from 'Images/misc/plus-sign-desktop.webp';
import PLUS_IMAGE_MOBILE from 'Images/misc/plus-sign-mobile.webp';
import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/half-pink-marble-mobile.png';
import styles from 'styles/pages/effectiveness.module.scss';

const HEAD = {
  title:
    'How Effective Is NEXPLANON® (etonogestrel implant) 68 mg Radiopaque for Birth Control?',
  description:
    'Learn how effective NEXPLANON® (etonogestrel implant) 68 mg Radiopaque is and how it helps prevent pregnancy.',
  keywords: 'How long does Nexplanon last, How does Nexplanon Work',
};

export default function Home() {
  const HeroBannerContent = () => (
    <div className={styles['content-wrap']} data-qa-tag="content-wrap">
      <RichText data-qa-tag="richtext-pregnancy-after-nexplanon">
        <div
          className={styles.pregnancyAfterNexplanonPage}
          data-qa-tag="pregnancy-after-nexplanon-page"
        >
          <h4 data-qa-tag="heading-how-effective">
            How Effective is NEXPLANON?
          </h4>

          <div
            className={styles.middleHeroText}
            data-qa-tag="paragraph-middle-hero"
          >
            <span>Nexplanon</span> is over 99%* effective in preventing
            pregnancy
          </div>

          <div
            className={styles.bottomHeroText}
            data-qa-tag="paragraph-bottom-hero"
          >
            NEXPLANON prevents pregnancy in several ways. The most important way
            is by stopping the release of an egg from your ovary. NEXPLANON
            doesn’t have to be taken every day, and it is one of the most
            effective birth controls available.
          </div>

          <p
            className={styles.captionText}
            data-qa-tag="paragraph-caption-text"
          >
            *Less than 1 pregnancy per 100 women who used NEXPLANON for 1 year.
          </p>
        </div>
      </RichText>
    </div>
  );

  return (
    <Layout head={HEAD}>
      <div className={styles.heroWrapper} data-qa-tag="hero-wrapper">
        <ItemBreakpoint breakpoint={'lg'} data-qa-tag="item-breakpoint-hero">
          <HeroFull
            image={HERO_BG_IMAGE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="How Effective is NEXPLANON?"
            data-design-module_no="01"
            data-qa-tag="hero-full-desktop"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-desktop" />
          </HeroFull>

          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="How Effective is NEXPLANON?"
            data-design-module_no="01"
            data-qa-tag="hero-full-mobile"
          >
            <HeroBannerContent data-qa-tag="hero-banner-content-mobile" />
          </HeroFull>
        </ItemBreakpoint>
      </div>

      <Pregnancies
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="what are some birth control options?"
        data-design-module_no="02"
      />

      <SplitContent
        reverse
        backgroundColor={'colored'}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="side effects of NEXPLANON"
        data-design-module_no="03"
        data-qa-tag="split-content-side-effects-colored"
      >
        <ItemBreakpoint
          breakpoint="lg"
          data-qa-tag="item-breakpoint-side-effects"
        >
          <AjustableImage
            size="full"
            image={{ src: PLUS_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
            data-qa-tag="image-plus-desktop"
          />
          <AjustableImage
            size="full"
            image={{ src: PLUS_IMAGE_MOBILE, alt: '' }}
            data-qa-tag="image-plus-mobile"
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="richtext-side-effects">
            <h2 data-qa-tag="heading-side-effects">
              Side effects of NEXPLANON
            </h2>
            <p className="intro-sm" data-qa-tag="paragraph-side-effects">
              The most common side effect of NEXPLANON is a change in your
              normal menstrual bleeding pattern. In studies, 1 in 10 women
              stopped using NEXPLANON because of an unfavorable change in their
              bleeding pattern. Besides changes in menstrual bleeding patterns,
              other frequent side effects that caused women to stop using the
              implant include mood swings, weight gain, headache, acne, and
              depressed mood.
            </p>
          </RichText>
          <Button
            href="/side-effects/"
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label="Side Effects of NEXPLANON"
            data-design-nori_id="Inline Content"
            data-design-module_name="side effects of NEXPLANON"
            data-design-module_no="04"
            data-qa-tag="button-side-effects"
          >
            Side Effects of NEXPLANON
          </Button>
        </>
      </SplitContent>
      <Finder data-design-module_no="05" data-qa-tag="finder-component" />
    </Layout>
  );
}
